import { Injectable, OnDestroy } from '@angular/core';
import { filter, fromEvent, Subject, takeUntil, tap } from 'rxjs';
import { DrawerStateManager } from './drawer-state.manager';

@Injectable({
  providedIn: 'root',
})
export class NavigationHandler implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly drawerStateManager: DrawerStateManager) {
    this.initializeBackButtonListener();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Handles navigation when back button is clicked
   * @returns True if navigation was handled successfully, false otherwise
   */
  handleBackNavigation(): boolean {
    const lastDrawerId = this.drawerStateManager.getLastDrawerId();
    if (lastDrawerId) {
      return this.drawerStateManager.closeDrawer(lastDrawerId);
    }
    return false;
  }

  /**
   * Manually trigger back navigation
   */
  goBack(): boolean {
    return this.handleBackNavigation();
  }

  private initializeBackButtonListener(): void {
    fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(
          ({ target }) =>
            (target as HTMLElement).closest('.back-button') !== null
        ),
        tap(() => this.handleBackNavigation()),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
}
